import React, { useEffect } from "react";
import ENV from "../../../config";

interface GeniusSiteTrackingProps {
  targetSelector: string;
  eventType: "click" | "input" | "change";
  pageName: string;
  accountID?: any;
  value?: any;
  currency?: any;
  trackPageLoad?: boolean;
}

const GeniusSiteTracking: React.FC<GeniusSiteTrackingProps> = ({
  targetSelector,
  eventType,
  pageName,
  accountID,
  value,
  currency,
  trackPageLoad = false,
}) => {
  // Base64 Encrypt Function (encryption needed as per Genius tagging requests)
  const encryptBase64 = (str: string) => {
    return btoa(str);
  };

  useEffect(() => {
    if (ENV.PRODUCTION !== "TRUE") {
      return; // Do not render anything if not in production
    }

    const handleEvent = () => {
      // Encrypt accountID if present
      const encryptedAccountID = accountID ? encryptBase64(accountID) : null;

      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: "Genius site tracking TEST",
        EncryptedAccountID: encryptedAccountID,
        Value: value,
        Currency: currency,
        PageName: pageName,
      });

      // Construct the script URL with or without accountID
      let scriptURL = `https://zz.connextra.com/dcs/tagController/tag/5750f979195a/${pageName}?Value=${value}&Currency=${currency}`;
      if (encryptedAccountID) {
        scriptURL += `&AccountID=${encodeURIComponent(encryptedAccountID)}`;
      }

      // Inject the Genius tracking script
      const script = document.createElement("script");
      script.src = scriptURL;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      // Remove the script after a short delay to avoid duplicate loading
      setTimeout(() => {
        document.body.removeChild(script);
      }, 1000);
    };

    if (trackPageLoad) {
      handleEvent();
    }

    const elements = document.querySelectorAll(targetSelector);
    elements.forEach(element => {
      element.addEventListener(eventType, handleEvent);
    });

    // Cleanup event listeners on component unmount
    return () => {
      elements.forEach(element => {
        element.removeEventListener(eventType, handleEvent);
      });
    };
  }, [
    targetSelector,
    eventType,
    pageName,
    accountID,
    value,
    currency,
    trackPageLoad,
  ]);

  return null;
};

export default GeniusSiteTracking;
